import type { GraphQLSchema } from 'graphql'
// @ts-expect-error graphql-scalars types are broken
import { BigIntResolver } from 'graphql-scalars'
import { makeExecutableSchema } from 'graphql-tools'

import resolvers from './resolvers'
import { typeDefs } from './typeDefs'

let schema: GraphQLSchema | undefined

// Built on first use: importing this module is common, building the schema is expensive. A build
// that throws is not cached, so the next call rethrows rather than returning nothing.
export const getSchema = () =>
  (schema ??= makeExecutableSchema({
    resolverValidationOptions: { requireResolversForResolveType: false },
    typeDefs,
    resolvers: { ...resolvers, BigInt: BigIntResolver },
  }))
